import type { SetupStatus } from '@welynk/types';

/**
 * The four setup steps people see (the server reports departments, programs and
 * batches separately; together they are one "academic structure" step). Used by
 * the wizard, the sidebar badge and the dashboard banner so they always agree.
 */
export function setupSteps(status: SetupStatus) {
  const s = (k: string) => status.steps.find((x) => x.key === k);
  return [
    { key: 'details', label: 'College details', done: !!s('profile')?.done },
    {
      key: 'structure',
      label: 'Academic structure',
      done: !!(s('departments')?.done && s('programs')?.done && s('batches')?.done),
    },
    { key: 'staff', label: 'Your team', done: !!s('staff')?.done },
    { key: 'students', label: 'Students', done: !!s('students')?.done },
  ] as const;
}

export function setupProgress(status: SetupStatus) {
  const steps = setupSteps(status);
  const done = steps.filter((x) => x.done).length;
  return { done, total: steps.length, left: steps.length - done };
}
